import sdl from '@jds/react-generated-sdl/JDSActionButton';
import type { JDSActionButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ActionButtonProps } from '../logic';

const Component = (props: ActionButtonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'primary',
    size = 'medium',
    appearance = 'normal',
    state = 'normal',
    iconPosition = 'left',
    stretch = false,
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      size,
      appearance,
      state,
      iconPosition,
      stretch,
      ariaLabel,
      ...rest
    },
    'JDSActionButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const ActionButton = withLogic(Component) as React.ForwardRefExoticComponent<
  ActionButtonProps & React.RefAttributes<HTMLButtonElement>
> & { slotName?: string };

ActionButton.displayName = 'ActionButton';
ActionButton.slotName = 'jds_action_button';

export { ActionButton, type JDSActionButtonProps };
